// pages/Unauthorized.jsx

import { PrimaryButton } from "common/Forms";

const UnauthorizedPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] gap-4">
      <h2 className="text-xl font-semibold">Access Denied</h2>
      <p className="text-gray-500">You don't have permission to view this page.</p>
      <PrimaryButton action={() => window.location.href = "/"}>
        Back
      </PrimaryButton>
    </div>
  );
};

export default UnauthorizedPage;